import { Logger } from '@/services/logger';

export const handleError = (err: unknown) => {
  if (err instanceof Error) {
    Logger.logError(err.message);
  } else {
    Logger.logError('Something went wrong');
  }
};
